$('#compatibility-selector .dropdown-item').on('click', function(e) {
    e.preventDefault();

    var title = $(this).text(),
        target = $(this).data('target'),
        parent = $(this).parents('#compatibility-selector');
    
    parent.find('.dropdown-toggle .dropdown-title').html(title);

    parent.find('.compatibility-content').each(function() {
        $(this).removeClass('active');
        if($(this).hasClass(target)) {
            $(this).addClass('active');
            $(this).find('.slider-accessories').slick('refresh');
        }
    });
});

var numSlick = 0;
$('.slider-accessories').each( function() {
    numSlick++;

    // Leader slider
    $(this).addClass( 'slider-' + numSlick ).slick({
        arrows: true,
        appendArrows: $(this).closest('.slider-container').find('.slick-arrows'),
        fade: false,
        dots: true,
        infinite: false,
        slide: '.slider-item',
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]

    });
});